import { Component, Input } from '@angular/core';
import { IBmiAnswerConfig } from '@care-portals/api-interfaces';
import { calculateBMI, formatHeight } from '@care-portals/data';

@Component({
  selector: 'common-bmi',
  templateUrl: './bmi.component.html',
  styleUrls: ['./bmi.component.less']
})
export class BmiComponent {
  @Input() data: any;
  @Input() answer: IBmiAnswerConfig;
  @Input() editMode = true;

  get config(): Required<
    Pick<
      IBmiAnswerConfig,
      | 'showLabel'
      | 'bmiLabel'
      | 'heightLabel'
      | 'weightLabel'
      | 'showHeight'
      | 'showWeight'
      | 'showCalculatedValues'
    >
  > {
    return {
      showLabel: this.answer?.showLabel ?? true,
      bmiLabel: this.answer?.bmiLabel ?? 'BMI',
      heightLabel: this.answer?.heightLabel ?? 'Height',
      weightLabel: this.answer?.weightLabel ?? 'Weight',
      showHeight: this.answer?.showHeight ?? true,
      showWeight: this.answer?.showWeight ?? true,
      showCalculatedValues: this.answer?.showCalculatedValues ?? true
    };
  }

  get bmiValue(): string {
    return (calculateBMI(this.data || {}) ?? '').toString();
  }

  get heightValue(): string {
    return formatHeight(this.data || {});
  }

  get weightValue(): string {
    const { weight, weightUnit } = this.data || {};
    return (weight || '') + (weightUnit ? ` ${weightUnit}` : '');
  }
}
